import styled, { keyframes } from "styled-components";
import React, { useState } from "react";
import { Radio } from "semantic-ui-react";

const Permissions = ({
  anchorName,
  pdfOptions,
  setPdfOptions,
  nomenclature,
  templateId,
  noData,
}) => {
  // Local state for UI purposes; note: includeWarning key must match what Create.js expects.
  const [options, setOptions] = useState({
    includeWarning: false,
  });

  const handleToggle = () => {
    const updated = !options.includeWarning;
    // Update local state
    setOptions({
      ...options,
      includeWarning: updated,
    });
    // Propagate the change to the parent component (PDFReportCreation)
    setPdfOptions({
      ...pdfOptions,
      includeWarning: updated,
    });
  };

  return (
    <Container>
      <T1>{nomenclature || "Report"} Options</T1>
      <Description>
        Please select the permissions that apply for the{" "}
        {nomenclature?.toLowerCase() || "report"} you are requesting to be
        generated.
      </Description>
      {templateId !== 9 && (
        <Card>
          <Option>
            <T2>
              Add {anchorName} warning message{" "}
              <Radio
                checked={options.includeWarning}
                onChange={handleToggle}
                toggle
              />
            </T2>
            <Text>
              This option will toggle a warning message that indicates how to
              interpret the results.
            </Text>
          </Option>
        </Card>
      )}
      {noData && <ErrorText>No data available to create the report.</ErrorText>}
    </Container>
  );
};

export default Permissions;

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
`;

const Container = styled.div`
  font-family: "Raleway";
`;

const T1 = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  font-family: "Raleway";
  color: #2a3039;
  line-height: 1.5;
  margin-top: 20px;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  letter-spacing: -0.35px;
`;

const Description = styled.div`
  font-size: 16px;
  color: #2a3039;
  margin-bottom: 20px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 0.5s;
`;

const Card = styled.div`
  width: 100%;
  padding: 20px;
  background-color: #ebf1fd;
  border-radius: 10px;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 1s;
`;

const Option = styled.div`
  margin-bottom: 20px;
`;

const T2 = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
`;

const Text = styled.div`
  max-width: 80%;
  line-height: 1.5;
`;

const ErrorText = styled.div`
  color: red;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`;
